import { defineConfig } from 'cva';
import { extendTailwindMerge } from 'tailwind-merge';

const twMergeCustom = extendTailwindMerge({
  override: {
    classGroups: {
      'font-size': [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'callout-bold',
        'subhead-bold',
        'body',
        'callout',
        'subhead',
      ],
    },
    theme: {
      colors: [
        'transparent',
        'text',
        'textHover',
        'background1',
        'background2',
        'card',
        'primary1',
        'primary2',
        'primary3',
        'success1',
        'success2',
        'warning1',
        'error',
        'info',
        'info2',
        'black1',
        'black3',
        'black5',
        'grey1',
        'grey3',
        'grey5',
        'grey6',
        'grey7',
        'purple',
        'elevation',
        'white',
        'borderPrimary',
        'borderSecondary',
      ],
    },
  },
});

export const {
  cva,
  cx: cn,
  compose,
} = defineConfig({
  hooks: {
    onComplete: (className) => twMergeCustom(className),
  },
});

export type { VariantProps } from 'cva';
